import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreSnippet } from '~/stores/strapi/snippet';
import { useStoreCurrencyMenu } from './../stores/strapi/currencyMenu';
import { useCurrencyConverter } from './useCurrencyConverter';

export const useSnippet = () => {
  const storeCurrencyMenu = useStoreCurrencyMenu();
  const currencyConverter = useCurrencyConverter();
  const listCryptoWithFiatRules = ['XRP', 'ADA', 'DOG', 'DOGE', 'TRX', 'USDT'];

  const rounding = (value: number, currency: string) => {
    if (storeCurrencyMenu.isFiatCurrency(currency)) {
      return value;
    }
    if (listCryptoWithFiatRules.includes(currency)) {
      const formattedValue = Number(value).toFixed(8);

      return parseFloat(formattedValue);
    }
    const precision =
      storeCurrencyMenu.currencies.find((c) => c.currencyCode === currency)?.precision || 0;
    return Number(value.toFixed(precision));
  };

  const format = (
    text: string,
    skipCurrency?: boolean,
    specificCurrency?: string,
    doNotShorten?: boolean
  ) => {
    const storeSnippet = useStoreSnippet();
    const storeCurrencyMenu = useStoreCurrencyMenu();

    const storeRoot = useStoreRoot();
    const userCurrency = specificCurrency || storeRoot.userCurrency;

    return text.replace(/\{[^}]*_auto_currency[^}]*\}/g, (value: string) => {
      const [autoCurrency, customCurrency] = value.replace(/\{|\}/g, '').split('_auto_currency');

      const customCurrencyObj = customCurrency.split(' / ').reduce((result, item) => {
        if (item) {
          const [v, k] = item.split(' ');
          result[k] = v;
        }
        return result;
      }, {} as Record<string, string>);

      const finalCurrencyValue =
        customCurrencyObj[userCurrency] !== undefined
          ? customCurrencyObj[userCurrency]
          : rounding(storeSnippet.data[userCurrency] * Number(autoCurrency), userCurrency);

      if (
        storeCurrencyMenu.cryptoCurrencyCodes.includes(userCurrency) &&
        userCurrency !== 'USDT' &&
        Number(finalCurrencyValue) < 1
      ) {
        const convertedCurrency = currencyConverter.convertToFormattedAmount(
          Number(finalCurrencyValue),
          userCurrency,
          true,
          doNotShorten
        );
        return skipCurrency
          ? `${convertedCurrency.formattedAmount}`
          : `${convertedCurrency.formattedAmount} ${convertedCurrency.formattedCurrency}`;
      }
      return skipCurrency ? `${finalCurrencyValue}` : `${finalCurrencyValue} ${userCurrency}`;
    });
  };

  return {
    format,
  };
};
